const _excluded = ["children", "renderSideNavigation", "style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@adsk/alloy-react-box';
import SideNavigation from '@adsk/alloy-side-navigation';

/**
 * Skeleton for side navigation frame
 */
const SideNavigationLayout = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      children,
      renderSideNavigation,
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Box, _extends({
    display: "flex",
    height: "100%"
  }, props, {
    ref: ref,
    style: style
  }), renderSideNavigation(), /*#__PURE__*/React.createElement(Box, {
    height: "100%",
    overflow: "auto",
    flex: 1
  }, children));
});
SideNavigationLayout.displayName = 'SideNavigationLayout';
SideNavigationLayout.defaultProps = {
  renderSideNavigation: props => /*#__PURE__*/React.createElement(SideNavigation, props)
};
SideNavigationLayout.propTypes = {
  /** Page content */
  children: PropTypes.node,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Side navigation render function */
  renderSideNavigation: PropTypes.func,
  /** Styles applied to the root element */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};
export default SideNavigationLayout;
//# sourceMappingURL=SideNavigationLayout.js.map